module.exports = __webpack_public_path__ + "img/fushimi-HP-nyuka-002.b36aab92.jpg";